import {Pinia} from 'pinia'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'
import {LocalPreferenceType} from '../../stores/LocalPreferenceStore/enum/LocalPreferenceType'
import {useLocalPreferenceStore} from '@toolify/client/src/stores/LocalPreferenceStore/useLocalPreferenceStore'
import {useWorkspaceStore} from '@toolify/client/src/stores/WorkspaceStore/useWorkspaceStore'
import {isGodModeEnabled} from '@toolify/client/src/stores/AdminRuntimeStore/functions/isGodModeEnabled'
import {RouteQueryKey} from '@toolify/client/src/setup/router/enum/RouteQueryKey'

export function beforeChooseWorkspaceRouterHookFactory(pinia: Pinia) {
  return async function beforeChooseWorkspaceRouterHook(to) {
    const workspaceStore = useWorkspaceStore(pinia)
    const localPreferenceStore = useLocalPreferenceStore(pinia)
    await workspaceStore.ensureMyWorkspaces()
    const workspaces = workspaceStore.myWorkspaces || []

    const continuePath = to.query.continue as string | undefined
    const isInvitationContinue = continuePath?.includes('/invitation/')
    if(isInvitationContinue && continuePath) {
      return continuePath
    }

    if(!workspaces.length) {
      return {
        name: RouteName.CreateWorkspace,
        query: {continue: continuePath},
      }
    }

    if(isGodModeEnabled()) {
      return
    }

    if(to.redirectedFrom && workspaces.some(workspace => workspace.name === to.query[RouteQueryKey.UnavailableWorkspace])) {
      return
    }

    if(workspaces.length === 1) {
      return {
        name: RouteName.WorkspaceHome,
        params: {
          workspaceName: workspaces[0].name,
        },
      }
    }

    if(workspaces.length) {
      let lastWorkspace = localPreferenceStore.get(LocalPreferenceType.LastWorkspaceName)
      if (!lastWorkspace || !workspaces.find(workspace => workspace.name === lastWorkspace)) {
        if (workspaceStore.currentWorkspace?.name && workspaces.find(workspace => workspace.name === workspaceStore.currentWorkspace.name)) {
          lastWorkspace = workspaceStore.currentWorkspace.name
        } else {
          lastWorkspace = workspaces[0]?.name
        }
      }
      
      return {
        name: RouteName.WorkspaceHome,
        params: {
          workspaceName: lastWorkspace,
        },
      }
    }
  }
}
